<template>
    <checkout></checkout>
</template>

<style lang="scss">

</style>

<script>
  import Checkout from '../components/Checkout.vue';

  export default {
    components: {
      Checkout
    }
  }
</script>
